export default __webpack_public_path__ + "static/media/logo.7878a612.svg";